<template>
  <v-card id="sms-journal-list">
    <v-card-title class="text-h6">
      Журнал SMS
    </v-card-title>

    <v-card-text>
      <v-row dense>
        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            v-model="filters.phone"
            dense
            outlined
            hide-details
            clearable
            label="Номер телефона"
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filters.status"
            :items="statusItems"
            dense
            outlined
            hide-details
            label="Статус"
          ></v-select>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <v-menu
            v-model="datesOpened"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                :value="datesLabel"
                readonly
                dense
                outlined
                hide-details
                clearable
                label="Период"
                :prepend-inner-icon="icons.mdiCalendarRange"
                v-bind="attrs"
                v-on="on"
                @click:clear="clearDates"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dates"
              range
              locale="ru"
              first-day-of-week="1"
              @change="applyDates"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-card-text>

    <v-data-table
      :headers="headers"
      :items="messages"
      :server-items-length="totalCount"
      :loading="loading"
      :page.sync="filters.pageNumber"
      :items-per-page.sync="filters.pageSize"
      :footer-props="{ 'items-per-page-options': [25, 50, 100] }"
      disable-sort
      class="text-no-wrap"
    >
      <template #[`item.createdAt`]="{item}">
        {{ toDateTimeString(item.createdAt) }}
      </template>

      <template #[`item.templateName`]="{item}">
        {{ item.templateName || item.templateCode || '—' }}
      </template>

      <template #[`item.body`]="{item}">
        <div class="sms-journal-text">
          {{ item.body }}
        </div>
      </template>

      <template #[`item.status`]="{item}">
        <v-chip
          small
          :color="statusColor(item.status)"
          text-color="white"
        >
          {{ item.statusName }}
        </v-chip>
      </template>

      <template #[`item.error`]="{item}">
        <div
          v-if="item.error"
          class="sms-journal-text error--text"
        >
          {{ item.error }}
        </div>
        <span v-else>—</span>
      </template>
    </v-data-table>

    <v-card-text class="text--secondary">
      Код подтверждения в журнале закрыт звёздочками.
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mdiCalendarRange } from '@mdi/js'
import { mapFormHandlers } from '@/helpers/forms'
import { toDateTimeString } from '@/helpers'
import { smsStatusColor, smsStatusItems } from '@/helpers/notifications'

export default {
  name: 'SmsJournalList',
  data: () => ({
    icons: { mdiCalendarRange },
    toDateTimeString,
    statusItems: smsStatusItems,
    datesOpened: false,
    dates: [],
  }),
  computed: {
    ...mapFormHandlers('smsJournal', [
      'filters.pageNumber',
      'filters.pageSize',
      'filters.phone',
      'filters.status',
      'filters.dateFrom',
      'filters.dateTo',
    ]),
    ...mapState('smsJournal', {
      messages: 'list',
      totalCount: 'totalCount',
      loading: 'loading',
    }),
    datesLabel() {
      const { dateFrom, dateTo } = this.filters

      if (!dateFrom) return ''

      return dateFrom === dateTo ? dateFrom : `${dateFrom} — ${dateTo}`
    },
    headers() {
      return [
        { text: 'Время', value: 'createdAt' },
        { text: 'Номер', value: 'phone' },
        { text: 'Шаблон', value: 'templateName' },
        { text: 'Текст', value: 'body' },
        { text: 'Статус', value: 'status' },
        { text: 'Ошибка', value: 'error' },
      ]
    },
  },
  async created() {
    document.title = 'Журнал SMS'

    this.dates = [this.filters.dateFrom, this.filters.dateTo].filter(x => x)
    await this.fetchList()
  },
  methods: {
    ...mapActions('smsJournal', ['fetchList']),
    statusColor(status) {
      return smsStatusColor(status)
    },

    applyDates(range) {
      const [first, second] = [...range].sort()

      this.filters.dateFrom = first
      this.filters.dateTo = second || first

      if (range.length === 2) this.datesOpened = false
    },
    clearDates() {
      this.dates = []
      this.filters.dateFrom = null
      this.filters.dateTo = null
    },
  },
}
</script>

<style lang="scss" scoped>
#sms-journal-list {
  .sms-journal-text {
    white-space: normal;
    min-width: 16rem;
  }
}
</style>
